import { FunctionComponent } from 'react';
import styles from './Metric.module.scss';
import clsx from 'clsx';
import Spinner from 'components/UI/V3/Spinner';
import { Metric as MetricModel } from '@spike/appointments-list-model';
interface MetricProps {
    data: MetricModel;
    loading?: boolean;
    className?: string;
}

export const Metric: FunctionComponent<MetricProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <span className={styles.label}>{props.data.label}</span>
            {props.loading ? <Spinner size={20} /> : <span className={styles.value}>{props.data.value}</span>}
        </div>
    );
};

export default Metric;
